import React from 'react';
import { getPortraitImage } from '../util/user';
import { Server } from 'src/server/server';
import '../pages/SitePage.css';

interface PortraitProps {
  user: string;
  size?: number;
  onClick?: Function;
  hideOnline?: boolean;
}

interface PortraitState {
  online: boolean;
}

class Portrait extends React.Component<PortraitProps, PortraitState> {
  constructor(props: PortraitProps) {
    super(props);
    this.state = {
      online: true
    }
    this.onFriendUpdated = this.onFriendUpdated.bind(this);
    this.onConnect = this.onConnect.bind(this);
    this.onDisconnect = this.onDisconnect.bind(this);
  }
  
  componentDidMount(): void {
    if(this.props.user == Server.user.getId()) {
      Server.network.addEventListener('connect', this.onConnect);
      Server.network.addEventListener('disconnect', this.onDisconnect);
      this.setState({online: Server.network.isConnected()})
    }

    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
  }

  componentWillUnmount() {
    if(this.props.user == Server.user.getId()) {
      Server.network.removeEventListener('connect', this.onConnect);
      Server.network.removeEventListener('disconnect', this.onDisconnect);
    }

    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  onConnect() {
    this.setState({online: true});
  }

  onDisconnect() {
    this.setState({online: false});
  }

  onFriendUpdated(data:any) {
    if(data.friend == this.props.user)
      this.forceUpdate();
  }

  onClick(e:any) {
    if(this.props.onClick) {
      e.preventDefault();
      e.stopPropagation();
      this.props.onClick(this.props.user);
    }
  }

  render() {
    let user = Server.public.getProfile(this.props.user);

    let online = false;
    if(Server.account.isLoggedIn()) {
      if(this.props.user == Server.user.getId()) 
        online = this.state.online;
      else {
        let presence = Server.user.getFriendPresence(this.props.user);
        online = (presence && presence.online);
      }
    }

    if(this.props.hideOnline)
      online = false;

    let size = 44;
    if(this.props.size)
      size *= this.props.size;

    let or = 12;
    if(this.props.size)
      or *= this.props.size;
    let onlineRadius = or + 'px'

    return (
      <div style={{display: 'flex', position: 'relative'}} onClick={(e:any)=>this.onClick(e)}>
        <img className="site-page-portrait" style={{width: size + 'px', height: size + 'px'}} src={getPortraitImage(user)} />
        {online &&
          <div className="site-page-online-circle" style={{width: onlineRadius, height: onlineRadius}}/>
        }
      </div>
    )
  }
}

export default Portrait;